import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { VideoStatusBadge } from '@/components/admin/feedback/VideoStatusBadge';
import { CompanionsList } from '@/components/admin/CompanionsList';
import type { MemoryDetail } from '@/types/admin';
import { formatDate } from '@/lib/date-utils';
import { isDemoMode, formatPrice } from '@/lib/demoPrice';
import { Calendar, Receipt } from 'lucide-react';

interface MemoryCardProps {
  memory: MemoryDetail;
  onCompanionClick?: (userId: string) => void;
}

/**
 * MemoryCard - Card showing complete memory detail
 */
export function MemoryCard({
  memory,
  onCompanionClick,
}: MemoryCardProps) {
  return (
    <Card className="hover:shadow-md transition-shadow">
      <CardHeader className="pb-3">
        <div className="flex items-start justify-between gap-4">
          <div className="space-y-1">
            <div className="flex items-center gap-2 text-sm text-gray-500">
              <Calendar className="h-4 w-4" />
              <span>{formatDate(memory.created_at)}</span>
            </div>
            <div className="flex items-center gap-2 text-sm text-gray-500">
              <Receipt className="h-4 w-4" />
              <span>Pedido #{memory.order.provider_order_id}</span>
            </div>
          </div>
          <VideoStatusBadge
            status={memory.video_status}
            viewsCount={memory.video_views_count}
            lastViewedAt={memory.last_viewed_at}
          />
        </div>
      </CardHeader>

      <CardContent className="space-y-4">
        {/* Order info */}
        <div className="grid grid-cols-2 gap-4 text-sm">
          <div>
            <span className="text-gray-500">Comensales:</span>{' '}
            <span className="font-medium">{memory.order.guests_count}</span>
          </div>
          {!isDemoMode && (
            <div>
              <span className="text-gray-500">Total:</span>{' '}
              <span className="font-medium">
                {formatPrice(memory.order.total_amount.amount, memory.order.total_amount.currency)}
              </span>
            </div>
          )}
        </div>

        {/* Companions */}
        {memory.order.companions.length > 0 && (
          <CompanionsList
            companions={memory.order.companions}
            onCompanionClick={onCompanionClick}
          />
        )}
      </CardContent>
    </Card>
  );
}
